import React, { useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Breadcrumb } from 'react-bootstrap';
import { heading3 } from '../Constants/Fonts';
const LABEL_MAP = {
    dashboard: 'Dashboard',
    'product-dashboard': 'Dashboard',
    freetools: 'Tools',
    recycle: 'Knowledge Base',
    settings: 'Settings',
};

export default function HeaderBreadcrumb({ hide }) {
    const location = useLocation();
    const crumbs = useMemo(() => {
        const parts = location.pathname.split('/').filter(Boolean);
        let cumulative = '';
        return parts.map((part, i) => {
            cumulative += `/${part}`;
            return {
                label: LABEL_MAP[part] ?? part.replace(/^\w/, c => c.toUpperCase()),
                path: cumulative,
                active: i === parts.length - 1,
            };
        });
    }, [location.pathname]);

    if (hide) {
        return null;
    }

    return (
        <Breadcrumb className="mb-0 display-flex align-items-center">
            {crumbs.map(c =>
                c.active ? (
                    <Breadcrumb.Item active key={c.path} className="mb-0 display-flex align-items-center">
                        {/* Current screen — same weight as its parents, full strength. */}
                        <span className='mb-0' style={heading3({ color: 'var(--color-text-primary)' })}>{c.label}</span>
                    </Breadcrumb.Item>
                ) : (
                    <Breadcrumb.Item
                        linkAs={Link}
                        linkProps={{ to: c.path }}
                        key={c.path}
                        className="mb-0"
                    >
                        {/* Parent crumbs — same size/weight, dimmed so the current
                            screen still leads. Opacity (not colour) because the
                            CommonHeader forces headerLeft text colour with !important. */}
                        <span style={heading3({ opacity: 0.5 })}>{c.label}</span>
                    </Breadcrumb.Item>
                )
            )}
        </Breadcrumb>
    );
}
